import { H4, Image, LI, P, UL } from '../../../AbstractElements';
import React, { Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Blogimgdate, Hits, MARKJENCO,  singleblogpara, Comments, BlogDetailPera1, BlogDetailPera2 } from '../../../Constant';

const BlogDetails = () => {
  return (
    <Fragment>
      <div className='blog-box blog-details'>
        <Card>
          <Image className='img-fluid w-100' src={require('../../../assets/images/faq/learning-1.jpg')} alt='blog-main' />
        </Card>
        <Card>
          <CardBody>
            <div className='blog-details'>
              <UL className='simple-list blog-social flex-row'>
                <LI className='digits'>{Blogimgdate}</LI>
                <LI>
                  <i className='icofont m-0 icofont-user'></i>
                  {MARKJENCO}
                </LI>
                <LI className='digits'>
                  <i className='icofont m-0 icofont-thumbs-up'></i>
                  {Hits}
                </LI>
                <LI className='digits'>
                  <i className='icofont m-0 icofont-ui-chat'></i>
                  {Comments}
                </LI>
              </UL>
              <H4>{singleblogpara}</H4>
              <div className='single-blog-content-top'>
                <P>{BlogDetailPera1}.</P>
                <P>{BlogDetailPera2}</P>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </Fragment>
  );
};

export default BlogDetails;
